import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useLanguage } from "../tools/LanguageContext";
import { Link } from "react-router-dom";
import axios from "axios";
import AddButton from "../tools/AddButton"
import DeleteButton from "../tools/DeleteButton"

function Articles() {
  const { translations, language } = useLanguage();
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [adminUsername, setAdminUsername] = useState(null);
  const token = localStorage.getItem("token");

  // Χρησιμοποιούμε το useEffect για να κάνουμε το αίτημα
  useEffect(() => {
    // Αρχικοποίηση του AOS
    AOS.init({
      duration: 1000,
    });

    // Αν η γλώσσα είναι "en", προσθέτουμε το query parameter "lang=en"
    const url = language === "en"
    ? "https://artofbetting.gr/api/articles?lang=en"
    : "https://artofbetting.gr/api/articles";

    // Κάνουμε το αίτημα στο backend
    axios
      .get(url)
      .then((response) => {
        setArticles(response.data.reverse());
        setLoading(false);
      })
      .catch((error) => {
        console.error("There was an error fetching the articles:", error);
      });

    const fetchAdminStatus = async () => {
      if (!token) {
        return;
      }

      try {
        const response = await axios.get("https://artofbetting.gr/api/get_admin_status", {
          headers: {
            "Authorization": token,
          }
        });
        if (response.data.admin_status) {
          setAdminUsername(response.data.admin_username);
        }
      } catch (error) {
        console.error("Error fetching admin status:", error);
      }
    };

    fetchAdminStatus();
  }, [token, language]); // Το useEffect εκτελείται μόνο κατά την αρχική φόρτωση της σελίδας

  const deleteArticle = async (id) => {
    try {
      await axios.post(`https://artofbetting.gr/api/delete_article/${id}`,
        {},
        {
          headers: {
            "Authorization": token,
          }
        }
      );

      // Ενημέρωση των αποτελεσμάτων μετά τη διαγραφή
      setArticles(articles.filter((article) => article.id !== id));

    } catch (error) {
      console.error("Error deleting article:", error);
      alert("Κάτι πήγε στραβά, δοκίμασε πάλι!");
    }
  };


  // Χειρισμός διαγραφής με επιβεβαίωση
  const handleDelete = (id) => {
    const confirmDelete = window.confirm("Θέλετε σίγουρα να διαγράψετε αυτό το άρθρο;");
    if (confirmDelete) {
      deleteArticle(id);
    }
  };

  const isTheTipster = (writer) => {
    return (
      (writer === "mrarber" && adminUsername === "Cucci39") ||
      (writer === "vretanos" && adminUsername === "billy10") ||
      (writer === "nole" && adminUsername === "DarleyDar")
    );
  };

  return (
    <div className="bg-gray-900 text-white min-h-screen p-4 w-full max-w-screen overflow-x-hidden">
      {/* Header */}
      <header className="flex justify-between items-center p-4 bg-gray-800 rounded-lg">
        <h1 className="text-3xl font-bold">ART OF BETTING</h1>
        <nav className="flex space-x-4">
          <Link to="/">
            <button className="bg-green-800 px-4 py-2 rounded hover:bg-green-900">
              {translations.home}
            </button>
          </Link>
        </nav>
      </header>

      {/* Content */}
      <main className="mt-6">
        <div className="flex w-full items-center gap-4 mb-4">
          <h2 className="text-3xl font-bold">{translations.articlesToday}</h2>
          { adminUsername !== null &&
            <Link to="/new_article">
              <AddButton/>
            </Link>
          }
        </div>
        {loading ? (
          <div className="text-center bg-green-800 p-4 rounded-lg">
            <p>{translations.loading}</p>
          </div>
        ) : (
          <div className="bg-gray-800 p-4 rounded-lg shadow-lg">
            {articles.length === 0 ? (
              <div className="text-center">
                <p>{translations.noArticles}</p>
              </div>
            ) : (
              articles.map((article, index) => (
                <div
                  className="flex flex-col md:flex-row justify-between items-center p-4 pb-6 border-b border-gray-700 last:border-b-0"
                  data-aos="fade-up"
                  data-aos-offset="100"
                  key={article.id}
                >
                  { isTheTipster(article.writer) && <DeleteButton onClick={() => handleDelete(article.id)} /> }

                  <div className="text-left md:flex-1 text-center p-2">
                    <h3 className="text-xl font-semibold">{article.title}</h3>
                  </div>

                  <div className="text-left md:flex-1 text-center">
                    <p className="text-gray-400">{
                      article.writer === "mrarber" ? translations.mrArber :
                      article.writer === "vretanos" ? translations.vretanos :
                      article.writer === "nole" ? translations.nole : ""}</p>
                  </div>

                  <div className="text-left md:flex-1 text-center">
                    <p className="text-gray-400">
                      {new Date(article.date).toLocaleDateString("el-GR")}
                    </p>
                  </div>

                  <div className="md:flex-1 text-center mt-6 md:text-right md:mt-0">
                    <Link to={`/article_analysis/${article.id}`} className="contents">
                      <span className="bg-green-800 px-4 py-2 rounded-lg">
                        {translations.readArticle}
                      </span>
                    </Link>
                  </div>

                </div>
              ))
            )}
          </div>
        )}
      </main>

      {/* Footer */}
      <footer className="relative w-full bg-gray-900 py-8">
        <div className="flex flex-col items-center justify-between w-full">
          <p className="text-xl font-bold border-b border-t p-4 mb-8">© Copyright 2025 Art Of Betting</p>
          <p className="text-lg font-bold border-b border-t p-2 mb-8 text-center">
            <span className="font-semibold">Διαφημιστειτε εδώ:</span>{' '}
            <a href="mailto:artofbetting2025@gmail.com" className="hover:underline">
              artofbetting2025@gmail.com
            </a>
          </p>

          <div className="flex items-center justify-between w-2/5 mb-8">
            <a href="https://www.kethea.gr/" target="_blank" rel="noopener noreferrer" className="w-1/5 mr-8">
              <img
                src="images/21.svg"
                alt="21+"
                className="w-full h-auto"
              />
            </a>

            <a href="https://www.kethea.gr/" target="_blank" rel="noopener noreferrer" className="w-4/5">
              <img
                src="images/kethea.svg"
                alt="kethea"
                className="w-full h-auto"
              />
            </a>
          </div>

          <a href="https://certifications.gamingcommission.gov.gr/publicRecordsOnline/SitePages/AffiliatesOnline.aspx" target="_blank" rel="noopener noreferrer">
            <img
              src="images/eeep.png"
              alt="eeep"
              className="w-full h-auto border-b border-t p-4"
            />
          </a>
        </div>
      </footer>
    </div>
  );
}

export default Articles;